import { useInitialState } from '../contexts/InitialStateContext';

export function useStudioSignupUrl() {
  const { locale, userData } = useInitialState();
  if (userData.isLoggedIn) {
    return 'https://www.wix.com/intro/studio?ref=studio_login';
  }
  return `https://users.wix.com/signin?studio=true&loginDialogContext=signup&postLogin=https:%2F%2Fwww.wix.com%2Fintro%2Fstudio%3Fref%3Dstudio_login&postSignUp=https:%2F%2Fwww.wix.com%2Fintro%2Fstudio%3Fref%3Dstudio_signup&overrideLocale=${locale}`;
}
